export const SET_FILE_MAPS = 'SET_FILE_MAPS';
export const CLEAR_FILE_MAPS = 'CLEAR_FILE_MAPS';
export const IS_SAVING_FILES = 'IS_SAVING_FILES';
export const POST_FILES_FAILURE = 'POST_FILES_FAILURE';
export const UPLOAD_FILES_FAILURE = 'UPLOAD_FILES_FAILURE';
export const COMPLETE_FILES_SUCCESS = 'COMPLETE_FILES_SUCCESS';
export const COMPLETE_FILES_FAILURE = 'COMPLETE_FILES_FAILURE';
export const SET_SELECTED_FILES = 'SET_SELECTED_FILES';
export const SET_DOCRIO_FILES = 'SET_DOCRIO_FILES';
export const GET_DOCRIO_FILES = 'GET_DOCRIO_FILES';
export const SET_FILE_SAVE_STATE = 'SET_FILE_SAVE_STATE';
export const SET_CURRENT_FILE_ID = 'SET_CURRENT_FILE_ID';
export const SET_FILES_SAVE_JOBS = 'SET_FILES_SAVE_JOBS';
export const CLEAR_FILE_SAVE_JOBS = 'CLEAR_FILE_SAVE_JOBS';
export const SET_SAVED_FILE_COUNT = 'SET_SAVED_FILE_COUNT';
export const SET_SKELETON_FILES = 'SET_SKELETON_FILES';
export const NAVIGATING_DOCRIO_FILES = 'NAVIGATING_DOCRIO_FILES';
export const LOADING_DOCRIO_FILES = 'LOADING_DOCRIO_FILES';
export const SET_ATTACHED_FILES = 'SET_ATTACHED_FILES';
export const REMOVE_FILE_MAP = 'REMOVE_FILE_MAP';
export const REMOVE_FILE_MAPS = 'REMOVE_FILE_MAPS';
export const REMOVE_FOLDER_PATH = 'REMOVE_FOLDER_PATH';
export const DISABLE_ADD_SAVE_LOCATION = 'DISABLE_ADD_SAVE_LOCATION';
export const SAVE_LOCATION_ADDED = 'SAVE_LOCATION_ADDED';
export const SET_FILE_VALIDATION_ERRORS = 'SET_FILE_VALIDATION_ERRORS';
export const SET_FILE_VALIDATION_PENDING = 'SET_FILE_VALIDATION_PENDING';
export const APPLY_DOC_ASSISTANT_FILE_RESULTS = 'APPLY_DOC_ASSISTANT_FILE_RESULTS';
export const CLEAR_DOC_ASSISTANT_PROCESSING = 'CLEAR_DOC_ASSISTANT_PROCESSING';
export const APPLY_DOC_ASSISTANT_SAVED_FILES = 'APPLY_DOC_ASSISTANT_SAVED_FILES';

export const setFileMaps = (fileMaps) => ({
  type: SET_FILE_MAPS,
  payload: {
    fileMaps,
  },
});

export const clearFileMaps = (selectedRecordId) => ({
  type: CLEAR_FILE_MAPS,
  selectedRecordId,
});

export const postFilesFailure = (error) => ({
  type: POST_FILES_FAILURE,
  payload: {
    error,
  },
});

export const uploadFilesFailure = (error) => ({
  type: UPLOAD_FILES_FAILURE,
  payload: {
    error,
  },
});

export const completeFilesSuccess = (files) => ({
  type: COMPLETE_FILES_SUCCESS,
  files,
});

export const completeFilesFailure = (error) => ({
  type: COMPLETE_FILES_FAILURE,
  payload: {
    error,
  },
});

export const setSelectedFiles = (selectedFiles) => ({
  type: SET_SELECTED_FILES,
  selectedFiles,
});

export const setDocrioFiles = (files) => ({
  type: SET_DOCRIO_FILES,
  files,
});

export const getDocrioFiles = () => ({
  type: GET_DOCRIO_FILES,
});

export const setFileSaveState = (status, file) => ({
  type: SET_FILE_SAVE_STATE,
  status,
  file,
});

export const setCurrentFileId = (fileId) => ({
  type: SET_CURRENT_FILE_ID,
  fileId,
});

export const setFilesSaveJobs = (jobIds) => ({
  type: SET_FILES_SAVE_JOBS,
  jobIds,
});

export const clearFileSaveJobs = () => ({
  type: CLEAR_FILE_SAVE_JOBS,
});

export const setSavedCount = (savedFileCount) => ({
  type: SET_SAVED_FILE_COUNT,
  savedFileCount,
});

export const skeletonFiles = (skeletonCount) => ({
  type: SET_SKELETON_FILES,
  skeletonCount,
});

// results: [{ hash, complete, fileName? }] from the doc-assistant capture status poll.
export const applyDocAssistantFileResults = (results) => ({
  type: APPLY_DOC_ASSISTANT_FILE_RESULTS,
  results,
});

export const clearDocAssistantProcessing = () => ({
  type: CLEAR_DOC_ASSISTANT_PROCESSING,
});

// files: [{ hash, docrioId, name }] derived from the backend's Doc Assistant reflection (the matter's
// attachments). Flags exactly the files that were matched/reparented as saved, with their docrioId and
// reparented name, so the rows show the saved/redirect state and the new name without a reload.
export const applyDocAssistantSavedFiles = (files) => ({
  type: APPLY_DOC_ASSISTANT_SAVED_FILES,
  files,
});

export const navigatingDocrioFiles = (value) => {
  return {
    type: NAVIGATING_DOCRIO_FILES,
    payload: value,
  };
};

export const loadingDocrioFiles = (value) => {
  return {
    type: LOADING_DOCRIO_FILES,
    payload: value,
  };
};

export const attachedFiles = (attachedFiles) => ({
  type: SET_ATTACHED_FILES,
  attachedFiles,
});

export const removeFileMap = (recordId) => ({
  type: REMOVE_FILE_MAP,
  recordId,
});

export const removeFolderPath = (recordId) => ({
  type: REMOVE_FOLDER_PATH,
  recordId,
});

export const setDisableAddSaveLocation = (value) => ({
  type: DISABLE_ADD_SAVE_LOCATION,
  payload: value,
});

export const setSaveLocationAdded = (value) => ({
  type: SAVE_LOCATION_ADDED,
  payload: value,
});

/**
 * Sets the per-file validation errors surfaced by the pre-upload dry-run.
 * @param {Object.<string, string[]>} errorsByFileId - map of file id to rule violation messages
 * @return {object} action
 */
export const setFileValidationErrors = (errorsByFileId) => ({
  type: SET_FILE_VALIDATION_ERRORS,
  errorsByFileId,
});

/**
 * Flags whether a pre-upload dry-run validation is currently in flight. Used to keep the Save
 * button disabled until the initial check has completed.
 * @param {boolean} pending - true while a validation request is running
 * @return {object} action
 */
export const setFileValidationPending = (pending) => ({
  type: SET_FILE_VALIDATION_PENDING,
  pending,
});
